import React, { useMemo } from 'react'
import { useMobileRecordContext } from "../../../contexts/mobileRecordContext"
import { findOrInitEntry } from "../../../utilities/mobileRecordHelper"
import EntryValue from './entryValue'

const HorizontalEntry = ({ field, map, report }) => {
  const { rootRecord } = useMobileRecordContext()
  const entry = useMemo(() => report || findOrInitEntry(field, rootRecord), [field, map, rootRecord])

  return (
    <table className='w-full border-collapse'>
      <tbody>
        <tr>
          <th
            className='w-1/2 py-2 font-semibold text-xs text-gray-600 uppercase text-left pr-2 whitespace-nowrap'>{field.label}</th>
          <td className='w-1/2'>
            <EntryValue entry={entry} field={field} map={map} />
          </td>
        </tr>
      </tbody>
    </table>
  )
}

export default HorizontalEntry
